var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-form', {
    ref: "form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.buscarNotificacoes.apply(null, arguments);
      }
    }
  }, [_c('v-row', {
    staticClass: "justify-center mt-3"
  }, [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Assunto da Notificação",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.assunto,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "assunto", $$v);
      },
      expression: "form.filters.assunto"
    }
  })], 1), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Início",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataInicio,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataInicio", $$v);
      },
      expression: "form.filters.dataInicio"
    }
  }), _c('sigfoco-date-picker', {
    attrs: {
      "cols": 2,
      "label": "Data Final",
      "removeIcon": "",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.dataFim,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "dataFim", $$v);
      },
      expression: "form.filters.dataFim"
    }
  }), _c('v-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Status",
      "items": _vm.form.lists.status,
      "item-text": "nome",
      "item-value": "value",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: _vm.form.filters.lida,
      callback: function ($$v) {
        _vm.$set(_vm.form.filters, "lida", $$v);
      },
      expression: "form.filters.lida"
    }
  })], 1)], 1), _c('div', {
    staticClass: "text-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('sigfoco-submit-button'), _c('sigfoco-tooltip', {
    attrs: {
      "text": 'Limpar',
      "icon": 'mdi-eraser'
    },
    on: {
      "click": function ($event) {
        return _vm.resetForm();
      }
    }
  })], 1)], 1)], 1), _c('v-data-table', {
    staticClass: "mt-5",
    attrs: {
      "headers": _vm.table.headers,
      "items": _vm.table.itens,
      "items-per-page": 10,
      "footer-props": _vm.$footerProps
    },
    scopedSlots: _vm._u([{
      key: `item.lida`,
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('span', [_vm._v(_vm._s(item.lida ? 'Lida' : 'Não Lida'))])];
      }
    }, {
      key: `item.dataNotificacao`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('span', [_vm._v(_vm._s(_vm.$formatarData(item.dataNotificacao)))])];
      }
    }, {
      key: `item.acoes`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('sigfoco-tooltip', {
          attrs: {
            "text": "Visualizar",
            "icon": "mdi-eye",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.openDialogVisualizarNotificacao(item.id);
            }
          }
        }), _c('sigfoco-tooltip', {
          attrs: {
            "text": "Excluir",
            "icon": "mdi-delete",
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.excluirNotificacao(item.id);
            }
          }
        })];
      }
    }], null, true)
  }), _c('VisualizarNotificacoesDialog', {
    attrs: {
      "visible": _vm.dialogVisualizarNotificacao.visible,
      "content": _vm.dialogVisualizarNotificacao.content
    },
    on: {
      "onClose": _vm.onCloseDialogNotificao
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }